document.addEventListener("DOMContentLoaded", function () {

    // Elfsight widgets (Instagram feed, Google reviews) render their own
    // "Free ... Widget" branding badge as a real <a href="...elfsight.com...">
    // inside a shadow root, styled via styled-components with an inline
    // style="...!important" set directly on the element. Inline-style
    // !important always beats a stylesheet !important for the same element,
    // so this can only ever be fixed in JS (confirmed via devtools - a CSS
    // rule targeting this link never had a chance). The widget re-renders
    // (e.g. on scroll/intersection) and resets that inline style each time,
    // so watching only the light-DOM container isn't enough - a
    // MutationObserver is attached directly to every shadow root found
    // (including ones that attach later) so the badge is re-hidden the
    // instant its inline style changes back.
    (function hideElfsightBadge() {
        var observedShadowRoots = new WeakSet();

        function hideBadgeLinks(root) {
            if (!root || !root.querySelectorAll) return;
            root.querySelectorAll('a[href*="elfsight.com"]').forEach(function (el) {
                el.style.setProperty('display', 'none', 'important');
            });
        }

        function watch(root) {
            if (!root || !root.querySelectorAll || observedShadowRoots.has(root)) return;
            observedShadowRoots.add(root);

            hideBadgeLinks(root);

            new MutationObserver(function () {
                hideBadgeLinks(root);
                attachToShadowRoots(root);
            }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

            attachToShadowRoots(root);
        }

        function attachToShadowRoots(root) {
            root.querySelectorAll('*').forEach(function (el) {
                if (el.shadowRoot) watch(el.shadowRoot);
            });
        }

        function sweep() {
            document.querySelectorAll('[class*="elfsight-app"]').forEach(watch);
        }

        sweep();
        [500, 1500, 3000, 6000, 10000].forEach(function (delay) {
            setTimeout(sweep, delay);
        });
    })();

    // All visible selects for gift box items
    const selects = document.querySelectorAll(
        ".product-parameters.box-dropdowns select.select__select"
    );

    // Loop through each select and map it to the corresponding hidden input
    selects.forEach((select, index) => {
        const hiddenInput = document.querySelector(
        `#product-box-item-${index + 1}`
        );

        if (!hiddenInput) return;

        // Function to update hidden input based on selected option
        const updateHiddenField = () => {
        hiddenInput.value = select.value.trim();
        };

        // Set initial default (in case selected_on_default=true)
        updateHiddenField();

        // Update when dropdown changes
        select.addEventListener("change", updateHiddenField);
    });

    // Block add-to-cart until every gift box item (Item 1, Item 2, ...) has a selection.
    // The page can render more than one .product-form__submit (e.g. a sticky/duplicate
    // add-to-cart button further down), so every one of them needs to be kept in sync.
    const giftBoxWarning = document.querySelector(".gift-box-select-warning");
    const giftBoxSubmitButtons = document.querySelectorAll(".product-form__submit");

    // Only ever re-enable via this check if the variant is actually purchasable
    // (the button only carries data-button-text when Shopify rendered it available).
    const giftBoxVariantAvailable = giftBoxSubmitButtons.length > 0
        ? giftBoxSubmitButtons[0].hasAttribute("data-button-text")
        : false;

    if (selects.length > 0 && giftBoxWarning && giftBoxSubmitButtons.length > 0 && giftBoxVariantAvailable) {
        const validateBoxSelections = () => {
        const allSelected = Array.from(selects).every((select) => select.value.trim() !== "");

        giftBoxWarning.style.display = allSelected ? "none" : "block";

        giftBoxSubmitButtons.forEach((button) => {
            if (allSelected) {
                button.removeAttribute("disabled");
            } else {
                button.setAttribute("disabled", "disabled");
            }
        });
        };

        validateBoxSelections();
        selects.forEach((select) => select.addEventListener("change", validateBoxSelections));

        const triggerShake = () => {
            giftBoxWarning.classList.remove("is-shaking");
            // Force reflow so the animation restarts if it's already mid-shake.
            void giftBoxWarning.offsetWidth;
            giftBoxWarning.classList.add("is-shaking");
        };

        giftBoxWarning.addEventListener("animationend", () => {
            giftBoxWarning.classList.remove("is-shaking");
        });

        // Disabled buttons don't fire "click" at all, so listen on each
        // button's parent instead - clicking anywhere over a disabled button
        // still fires a click on its nearest enabled ancestor.
        giftBoxSubmitButtons.forEach((button) => {
            const submitRow = button.closest(".product-form__buttons-row") || button.parentElement;
            if (!submitRow) return;
            submitRow.addEventListener("click", () => {
                if (!button.hasAttribute("disabled")) return;
                triggerShake();
            });
        });
    }

    // Custom image picker UI for gift box items (Item 1, Item 2, ...).
    // Keeps the real <select> in the DOM (hidden) so the sync/validation logic
    // above keeps working unchanged - this just drives that select via clicks
    // instead of the native dropdown, and dispatches a real "change" event.
    document.querySelectorAll("[data-gift-box-picker]").forEach((picker) => {
        const trigger = picker.querySelector("[data-gift-box-trigger]");
        const list = picker.querySelector("[data-gift-box-list]");
        const nativeSelect = picker.querySelector("[data-gift-box-native-select]");
        const triggerMedia = picker.querySelector("[data-gift-box-trigger-media]");
        const triggerLabel = picker.querySelector("[data-gift-box-trigger-label]");

        if (!trigger || !list || !nativeSelect) return;

        let closeTimer = null;

        const closeList = () => {
            clearTimeout(closeTimer);
            list.classList.remove("is-open");
            trigger.setAttribute("aria-expanded", "false");
            // Wait for the CSS transition to finish before removing it from
            // layout, otherwise it snaps shut instead of animating out.
            closeTimer = window.setTimeout(() => {
                list.hidden = true;
            }, 150);
        };

        const openList = () => {
            clearTimeout(closeTimer);
            list.hidden = false;
            trigger.setAttribute("aria-expanded", "true");
            // A transition can't animate across the display:none boundary,
            // so wait a frame after un-hiding before adding the open state.
            requestAnimationFrame(() => {
                list.classList.add("is-open");
            });
        };

        trigger.addEventListener("click", (e) => {
            e.stopPropagation();
            list.hidden ? openList() : closeList();
        });

        list.querySelectorAll("[data-gift-box-option]").forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.dataset.value;
                const label = option.dataset.label;
                const image = option.dataset.image;

                nativeSelect.value = value;
                nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));

                if (triggerLabel) triggerLabel.textContent = label;
                if (triggerMedia) {
                    if (image) {
                        triggerMedia.innerHTML = `<img src="${image}" width="32" height="32" alt="${label}" loading="lazy">`;
                        triggerMedia.hidden = false;
                    } else {
                        triggerMedia.innerHTML = "";
                        triggerMedia.hidden = true;
                    }
                }

                list.querySelectorAll("[data-gift-box-option]").forEach((opt) => {
                    opt.setAttribute("aria-selected", opt === option ? "true" : "false");
                });

                closeList();
            });
        });

        document.addEventListener("click", (e) => {
            if (!picker.contains(e.target)) closeList();
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") closeList();
        });
    });

    // Same image-picker pattern as the gift box items above, but for a real
    // product option/variant select (Bundle product pages only - the native
    // <select> stays in the DOM so Shopify's own variant-swap JS keeps working,
    // this just drives it via clicks and dispatches a real "change" event.
    document.querySelectorAll("[data-bundle-option-picker]").forEach((picker) => {
        const trigger = picker.querySelector("[data-bundle-option-trigger]");
        const list = picker.querySelector("[data-bundle-option-list]");
        const nativeSelect = picker.querySelector("[data-bundle-option-native-select]");
        const mirrorInput = picker.querySelector("[data-bundle-mirror-input]");
        const triggerMedia = picker.querySelector("[data-bundle-option-trigger-media]");
        const triggerLabel = picker.querySelector("[data-bundle-option-trigger-label]");

        if (!trigger || !list || !nativeSelect) return;

        let closeTimer = null;

        const closeList = () => {
            clearTimeout(closeTimer);
            list.classList.remove("is-open");
            trigger.setAttribute("aria-expanded", "false");
            closeTimer = window.setTimeout(() => {
                list.hidden = true;
            }, 150);
        };

        const openList = () => {
            clearTimeout(closeTimer);
            list.hidden = false;
            trigger.setAttribute("aria-expanded", "true");
            requestAnimationFrame(() => {
                list.classList.add("is-open");
            });
        };

        trigger.addEventListener("click", (e) => {
            e.stopPropagation();
            list.hidden ? openList() : closeList();
        });

        list.querySelectorAll("[data-bundle-option-option]").forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.dataset.value;
                const label = option.dataset.label;
                const image = option.dataset.image;
                const mirrorValue = option.dataset.mirrorValue;

                nativeSelect.value = value;
                nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));

                // Keep the Giftship/order-summary "Item N" property in sync with
                // whichever colour is actually selected on the real variant picker.
                if (mirrorInput && mirrorValue) mirrorInput.value = mirrorValue;

                if (triggerLabel) triggerLabel.textContent = label;
                if (triggerMedia) {
                    if (image) {
                        triggerMedia.innerHTML = `<img src="${image}" width="32" height="32" alt="${label}" loading="lazy">`;
                        triggerMedia.hidden = false;
                    } else {
                        triggerMedia.innerHTML = "";
                        triggerMedia.hidden = true;
                    }
                }

                list.querySelectorAll("[data-bundle-option-option]").forEach((opt) => {
                    opt.setAttribute("aria-selected", opt === option ? "true" : "false");
                });

                closeList();
            });
        });

        document.addEventListener("click", (e) => {
            if (!picker.contains(e.target)) closeList();
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") closeList();
        });
    });



    const thisIsaGift = document.querySelector(".a-gift");
    const hiddenPurposeInput = document.getElementById("product-purpose");
    const hiddenPackagingInput = document.getElementById("product-packaging");
    if (thisIsaGift && hiddenPurposeInput && hiddenPackagingInput) {
        thisIsaGift.addEventListener("change", function() {
            if (thisIsaGift.checked) {
                hiddenPurposeInput.value = "This is a gift";
                hiddenPackagingInput.value = "Wrap in a gift box";
            } else {
                hiddenPurposeInput.value = "";
                hiddenPackagingInput.value = "";
            }
        });
    }

    var sectionOff = document.querySelector(".section-off-js");
    if (sectionOff) {
        var section = sectionOff.closest("section");
        if (section) {
        section.classList.add("section-disable");
        }
    }

    const giftTextarea = document.querySelector(".gift-msg");
    const hiddenGiftInput = document.getElementById("gifting-message");
    if (giftTextarea && hiddenGiftInput) {
        giftTextarea.addEventListener("input", function() {
            hiddenGiftInput.value = this.value;
        });
    }

    // const giftNameField = document.querySelector(".gift-fullname");
    // const hiddenGiftNameInput = document.getElementById("gifting-fullname");
    // if (giftNameField && hiddenGiftNameInput) {
    //     giftNameField.addEventListener("input", function() {
    //         hiddenGiftNameInput.value = this.value;
    //     });
    // }
    // const giftAddressField = document.querySelector(".gift-address");
    // const hiddenGiftAddressInput = document.getElementById("gifting-address");
    // if (giftAddressField && hiddenGiftAddressInput) {
    //     giftAddressField.addEventListener("input", function() {
    //         hiddenGiftAddressInput.value = this.value;
    //     });
    // }
});
